<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main box-panel shadow max-w max-gs" id="page-content-main">
    <div class="m--pa4">
      <h2 class="mb-5">Accessibility Statement</h2>
      <p>
        This site has been evaluated for compliance with existing accessibility guidelines,
        including Section 508 of the US Rehabilitation Act and the W3C&rsquo;s Web Content
        Accessibility Guidelines (WCAG 2.1).
      </p>

      <br>

      <div class="alert alert-primary bg-primary-subtle" role="alert">
        <a download="Tennessee State Disbursement Unit Accessibility Conformance Report" target="_blank" style="color: #2f6792"
          href="../../../../../assets/help/Tennessee State Disbursement Unit Accessibility Conformance Report.pdf">
          <i class="fa fa-file-text mx-2" aria-hidden="true"></i>
          Tennessee State Disbursement Unit Accessibility Conformance Report
        </a>
      </div>

    </div>
  </div>
</epay-page-content>
